module.exports = __webpack_public_path__ + "img/DE06076.3d8c20ad.svg";